import React from 'react';

export const EditIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7498 7.15973L16.8398 10.2497M5.29276 15.6187L15.6188 5.29274C16.0088 4.90274 16.6418 4.90274 17.0318 5.29274L18.7078 6.96874C19.0978 7.35874 19.0978 7.99174 18.7078 8.38174L8.38076 18.7067C8.19376 18.8947 7.93976 18.9997 7.67476 18.9997H4.99976V16.3247C4.99976 16.0597 5.10476 15.8057 5.29276 15.6187Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
